import { render, staticRenderFns } from "./box7.vue?vue&type=template&id=30a40adc&scoped=true&"
import script from "./box7.vue?vue&type=script&lang=js&"
export * from "./box7.vue?vue&type=script&lang=js&"
import style0 from "./box7.vue?vue&type=style&index=0&id=30a40adc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a40adc",
  null
  
)

export default component.exports